import React from 'react';
import PropTypes from 'prop-types';

import {getPlayerHeight} from './utils';

import styles from './stream-video.module.css';

const StreamVideo = props => {
  const height = getPlayerHeight();
  const newProps = props.height ? {...props} : {...props, height};

  return (
    <div className={styles.streamWrapper}>
      <iframe {...newProps} />
    </div>
  );
};

StreamVideo.propTypes = {
  src: PropTypes.string,
  allowFullScreen: PropTypes.bool,
  height: PropTypes.string,
  width: PropTypes.string,
  autoPlay: PropTypes.bool,
  muted: PropTypes.bool
};

StreamVideo.defaultProps = {
  src: 'https://player.twitch.tv/?channel=dota2ti_ru&parent=www.local.gsec.pro&parent=www.stage.aws-nur.gsec.pro&parent=www.nur.kz', /* eslint-disable-line */
  allowFullScreen: true,
  height: '',
  width: '100%',
  autoPlay: true,
  muted: false
};

export default StreamVideo;
